import React, { useEffect, useState } from 'react'
import {
    Box,
    TextField, Tabs, Tab,
    Card, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Alert, Snackbar
}
    from '@mui/material'
import Table from '@mui/material/Table';
import Checkbox from '@mui/material/Checkbox';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import {Link, useNavigate} from 'react-router-dom';
import axiosInstance from '../axiosConfig';
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

export default function CateringOrders() {
  const [cateringOrders, setCateringOrders] = useState([])
  const [filteredCustomerCateringMenus, setFilteredCustomerCateringMenus] = useState([])
  const [selectedCustomerAddCateringMenus, setSelectedCustomerAddCateringMenus] = useState([])
  const [openEdit, setOpenEdit] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState("")
  const [snackbarSeverity, setSnackbarSeverity] = useState('success')
  const [filterText, setFilterText] = useState("")
  const [page, setPage] = useState(0);  // Current page index
  const [rowsPerPage, setRowsPerPage] = useState(5);  // Number of rows per page
  const [open, setOpen] = useState(false);  // State to control the Dialog visibility
  const [activeTab, setActiveTab] = useState(0);  // State to track active tab
  const [cateringMenus, setCateringMenus] = useState([])
  const [addMenuPage, setAddMenuPage] = useState(0);  // Current page index
  const [rowsPerAddMenuPage, setRowsPerAddMenuPage] = useState(5);  // Number of rows per page
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const serviceAPI = process.env.REACT_APP_API_SERVICE;

  const navigate = useNavigate();
    const [editCateringOrder, setEditCateringOrder] = useState({
        customerId:'',
        customerName: '',
        email: '',
        phone:'',
        guests: '',
        eventDate: null,
        eventTime:'',
        address: '',
        adultCount:'',
        kidsCount:'',
        deliveryType:'',
        selectedMenuItems:'',
        cateringOrderNumber:'',
        total:'',
        discount:'',
        finalPrice:''
    })

    const [customerCateringMenus, setCustomerCateringMenus] = useState([{
        customerId:'',
        cateringOrderId:'',
        menuItemName:'',
        menuId:'',
        customerSelectedMenuId:'',
        category:'',
        price:'',
        size:'',
        quantity:'',
    }])


const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);  // Update the active tab
};

const handleSnackbarClose = () => {
        setSnackbarOpen(false)
    }

const handleClose = () => {
    setOpen(false);  // Close the Dialog
};

const handleOpen = () => {
    setOpen(true);  // Open the Dialog
};

    const [editingRowId, setEditingRowId] = useState(null);

    const filteredCateringOrders  = cateringOrders.filter( cateringOrder =>
        (cateringOrder.customerName && cateringOrder.customerName.toLowerCase().includes(filterText.toLocaleLowerCase())) ||
        (cateringOrder.eventDate && cateringOrder.eventDate.toLowerCase().includes(filterText.toLocaleLowerCase()))
    );

    useEffect(() => {
        if (customerCateringMenus) {
            const filteredMenus = customerCateringMenus.filter((menu) =>
                menu.menuItemName?.toLowerCase().includes(filterText.toLowerCase())
            );
            setFilteredCustomerCateringMenus(filteredMenus);
        }
    }, [customerCateringMenus, filterText]);

// Handle input change for inline editing
    const handleInputChange = (id, field, value) => {
        setFilteredCustomerCateringMenus((prevData) =>
            prevData.map((item) =>
                item.customerSelectedMenuId === id ? { ...item, [field]: value } : item
            )
        );
    };

    // Handle edit click
    const handleEditClick = (id) => {
        setEditingRowId(id);
    };

    // Handle save click
    const handleSaveClick =  async (event) => {
        setEditingRowId(null); // Exit edit mode after saving
        console.log("updated Row..",editingRowId);
        console.log("updated Row..", filteredCustomerCateringMenus.find(record => record.customerSelectedMenuId === editingRowId));
        await axiosInstance.post(`${serviceAPI}/orders/catering/customer/menu/update/${editingRowId}`, {
            ...filteredCustomerCateringMenus.find(record => record.customerSelectedMenuId === editingRowId)// Set current datetime
        });
        setSnackbarMessage("Items updated  successfully!")
        setSnackbarSeverity("success")
        setRefreshTrigger(prev => !prev);
        setSnackbarOpen(true)
        setActiveTab(0)
    };

    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu`,{withCredentials: true}).then(response => {
            setCateringMenus(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the catering menus", error)
        })
    }, []);

    useEffect(() => {
    axiosInstance.get(`${serviceAPI}/orders/catering`,{withCredentials: true}).then(response => {
      setCateringOrders(response.data)
    }).catch((error) => {
      console.log("There was an error fetching the catering Orders", error)
    })
  }, [refreshTrigger]);

    const handleFilterChange = (event) => {
        setFilterText(event.target.value)
        setPage(0)
    }
    const handleCloseEdit = () => {
        setOpenEdit(false)
    }


    const handleClickOpenEdit = (cateringOrder) => {

        console.log("selected row discounted price",cateringOrder.finalPrice)
            setEditCateringOrder(cateringOrder)
            axiosInstance.get(`${serviceAPI}/orders/catering/customer/${cateringOrder.cateringOrderNumber}`).then(response => {
            setCustomerCateringMenus(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the categories", error)
        })
        setOpenEdit(true)
    }



    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };

    // Handle page change
  const handleChangePage = (event, newPage) => {
        setPage(newPage);
  };

    // Handle page change
    const handleAddChangePage = (event, newPage) => {
        setAddMenuPage(newPage);
    };
  // Handle change in rows per page
const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);  // Reset the table to the first page whenever rows per page changes
};

    // Handle change in rows per page
const handleAddChangeRowsPerPage = (event) => {
        setRowsPerAddMenuPage(parseInt(event.target.value, 10));
        setAddMenuPage(0);  // Reset the table to the first page whenever rows per page changes
    };
const filteredCateringMenus  = cateringMenus.filter( cateringMenu =>
    (cateringMenu.name && cateringMenu.name.toLowerCase().includes(filterText.toLocaleLowerCase())) ||
    (cateringMenu.summary && cateringMenu.summary.toLowerCase().includes(filterText.toLocaleLowerCase()))
);


 const handleEditCateringOrder = async () => {
        setSnackbarOpen(true)
    try {
        const updatedCateringOrder ={
            editCateringOrder:editCateringOrder,
            customerId:editCateringOrder.customerId,
            cateringOrderNumber:editCateringOrder.cateringOrderNumber
        }
        await axiosInstance.post(`${serviceAPI}/orders/catering/update`, {
            ...updatedCateringOrder// Set current datetime
        });
        setRefreshTrigger(prev => !prev);
        setSnackbarMessage("Catering Order Menu was updated successfully!")
        setSnackbarSeverity("success")
        setSnackbarOpen(true)
        handleCloseEdit();
    } catch (error) {
        setSnackbarMessage("There was an error updating the Catering Order Menu! Please try again")
        setSnackbarSeverity("warning")
        console.log('Error occured updating the menu', error)
    }
}

const handleAddOrder =(event) => {
        navigate("/cateringsenquiry");
    }

 const handleAddItem = async (event) => {
    event.preventDefault()
     console.log("selected new Additional Items..",selectedCustomerAddCateringMenus);
     const updatedCateringOrder ={
         cateringMenus:selectedCustomerAddCateringMenus,
         customerId:editCateringOrder.customerId,
         cateringOrderNumber:editCateringOrder.cateringOrderNumber
     }
     await axiosInstance.post(`${serviceAPI}/orders/catering/customer/additems`, {
         ...updatedCateringOrder// Set current datetime
     });
     setSnackbarMessage("Items added  successfully!")
     setSnackbarSeverity("success")
     setRefreshTrigger(prev => !prev);
     setSnackbarOpen(true)
     setActiveTab(0)
 }


    const handleDeleteMenuItem = async (customerSelectedMenuId) => {
        console.log("selected Item for delete..",customerSelectedMenuId);
        await axiosInstance.delete(`${serviceAPI}/orders/catering/customer/${customerSelectedMenuId}`);
        setSnackbarMessage("Item removed successfully!")
        setSnackbarSeverity("success")
        setRefreshTrigger(prev => !prev);
        setActiveTab(0)
        setSnackbarOpen(true)
        setOpenEdit(true)
    }

 useEffect(() => {
     console.log("Dialog open:", openEdit, "Active Tab:", activeTab);
    if (openEdit && activeTab === 0) { // Ensure dialog is open & correct tab is selected
        axiosInstance.get(`${serviceAPI}/orders/catering/customer/${editCateringOrder.cateringOrderNumber}`).then(customerMenuResponse => {
            setCustomerCateringMenus(customerMenuResponse.data)
            console.log("new updated menu size",customerCateringMenus.length)
        }).catch((error) => {
            console.log("There was an error fetching the updated menu", error)
        })
        console.log("calculating the final price for during edit function "+editCateringOrder.total)
        const finalPrice = Number(editCateringOrder.total || 0) -
            (Number(editCateringOrder.total || 0) * 0.01 * Number(editCateringOrder.discount || 0));

        setEditCateringOrder((prev) => ({
            ...prev,
            finalPrice: finalPrice,discount: editCateringOrder.discount
        }));
    }
}, [openEdit, activeTab,refreshTrigger]); // Re-run when dialog opens or tab switches


const handleChangeEdit = (e) => {
        setEditCateringOrder({...editCateringOrder, [e.target.name]: e.target.value})
    }
    // Handle row selection
    const handleAdditionalMenuRow = (event, row) => {
        // Check if the row is already selected
        const selectedIndex = selectedCustomerAddCateringMenus.findIndex(
            (selectedRow) => selectedRow.id === row.id
        );
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = newSelectedRows.concat(selectedCustomerAddCateringMenus, row); // Add to selection
        } else {
            newSelectedRows = newSelectedRows.concat(
                selectedCustomerAddCateringMenus.slice(0, selectedIndex),
                selectedCustomerAddCateringMenus.slice(selectedIndex + 1)
            ); // Remove from selection
        }

        setSelectedCustomerAddCateringMenus(newSelectedRows);
    };


    // Function to calculate the total of the price column
    const calculateTotalPrice = (e) => {
        const totalPrice = filteredCustomerCateringMenus.reduce((total, item) => total + item.price * item.quantity, 0);
        // Store the calculated value in the form state
        return totalPrice;
    };


/*..

     // Function to calculate the total of the price column
    const calculateDiscountedPrice = (e) => {
        const finalPrice = filteredCustomerCateringMenus.reduce((total, item) => total + item.price * item.quantity*(1-(item.discount)/100), 0);
        // Store the calculated value in the form state
        editCateringOrder.finalPrice = finalPrice;
    };

..*/


    useEffect(() => {
        setEditCateringOrder((prev) => {
            const totalPrice = filteredCustomerCateringMenus.reduce((total, item) => total + item.price * item.quantity, 0);
            const finalPrice = Number(totalPrice || 0) -
                (Number(totalPrice || 0) * 0.01 * Number(prev.discount || 0));
            return {
                ...prev,
                finalPrice: finalPrice,
                total: totalPrice,
                discount: prev.discount, // Keep the discount unchanged
            };
        });
    }, [filteredCustomerCateringMenus, editCateringOrder.discount]);


// Handle checkbox state
    const isAdditionalMenuSelected = (row) => selectedCustomerAddCateringMenus.indexOf(row) !== -1;


  return (
    <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="20%"
    padding="2rem"
    border="ActiveBorder"
    fullWidth
  >
    <Card sx={{ width: '90%', padding: '2rem', border: '2px solid black', borderRadius: '8px' }}>
    <TableContainer>
        <Box display="flex" justifyContent="flex-start" >
            <Button color="primary" variant="contained"  onClick={handleAddOrder} >
                Add Order
            </Button>
        </Box>
        <Box display="flex" justifyContent="flex-end" >
          <TextField
            label="Search Orders"
            variant="outlined"
            value={filterText}
            onChange={handleFilterChange}
          >
          </TextField>
        </Box>
        <hr></hr>
        <Table aria-label="simple table">
            <TableHead>
              <TableRow>
              <TableCell scope="col"></TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Id</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Customer</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Email Address</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Phone Number</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Event Date</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope='col'>Event Time</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Delivery</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Address</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Total($))</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} scope="col">Discounted Total($))</TableCell>
              <TableCell scope="col"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                { filteredCateringOrders !== null? filteredCateringOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((cateringOrder, index) => (
                <TableRow
                key={cateringOrder.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align='center'>
                    <IconButton color='secondary' onClick={() => handleClickOpenEdit(cateringOrder)}>
                        <EditIcon />
                    </IconButton>
                </TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.cateringOrderNumber}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.customerName}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.email}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.phone}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{formatDate(cateringOrder.eventDate)}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.eventTime}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.deliveryType}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.address}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.total}</TableCell>
                <TableCell sx={{ fontSize: '0.9rem', height: '10px' }}>{cateringOrder.finalPrice}</TableCell>
                </TableRow>
                ) ): (<TableRow><TableCell>Loading... </TableCell></TableRow>)}
            </TableBody>
          </Table>
          <TablePagination  sx={{ fontSize: '1.1rem' }}
            component="div"
            count={cateringOrders!= null? cateringOrders.length: 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}  // Options for rows per page
        />
      </TableContainer>
      <hr></hr>
    </Card>

        {/* Modal Dialog for Editing Catering Order */}
        <Dialog open={openEdit} onClose={handleCloseEdit} sx={{
            "& .MuiDialog-paper": {
                width: "80%", // Set the width of the Dialog to 80%
                maxWidth: "none", // Prevent Material UI from applying max-width
            },
        }}>
            <DialogTitle>Edit Catering Order</DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    name="Customer Name"
                    label="Customer Name"
                    type="text"
                    value={editCateringOrder.customerName}
                    onChange={handleChangeEdit}
                    style={{ width: "150px" }}
                />
                <TextField
                    margin="dense"
                    name="EmailAddress"
                    label="Email Address"
                    type="text"
                    value={editCateringOrder.email}
                    onChange={handleChangeEdit}
                    style={{ width: "250px" }}
                />
                <TextField
                    margin="dense"
                    name="eventDate"
                    label="Event Date"
                    type="text"
                    value={formatDate(editCateringOrder.eventDate)}
                    onChange={handleChangeEdit}
                    style={{ width: "150px" }}
                />
                <TextField
                    margin="dense"
                    name="eventTime"
                    label="Event Time"
                    type="text"
                    value={editCateringOrder.eventTime}
                    onChange={handleChangeEdit}
                    style={{ width: "100px" }}
                />
                <TextField
                    margin="dense"
                    name="phone"
                    label="Phone Number"
                    type="text"
                    value={editCateringOrder.phone}
                    onChange={handleChangeEdit}
                    style={{ width: "120px" }}
                />
                <TextField
                    margin="dense"
                    name="totalPrice"
                    label="Total Price ($)"
                    type="number"
                    style={{ width: "100px" }}
                    value={calculateTotalPrice()}
                    onChange={handleChangeEdit}
                />
                <TextField
                    margin="dense"
                    name="discount"
                    label="Discount(%)"
                    type="number"
                    style={{ width: "100px" }}
                    value={editCateringOrder.discount || 0}
                    onChange={handleChangeEdit}
                />
                <TextField
                    margin="dense"
                    name="finalPrice"
                    label="Final Price ($)"
                    type="number"
                    style={{ width: "110px" }}
                    value={editCateringOrder.finalPrice||0}
                    onChange={handleChangeEdit}
                />
                <Tabs value={activeTab} onChange={handleTabChange} aria-label="tabs inside dialog">
                    <Tab label="Details">
                    </Tab>
                    <Tab label="Menu Catalog" >
                    </Tab>
                </Tabs>
                <Box sx={{ paddingTop: 2 }}>
                    {activeTab === 0 && (
                        <TableContainer>
                            <Box display="flex" justifyContent="flex-end" padding='2'>
                                <TextField
                                    label="Search Menu"
                                    variant="outlined"
                                    value={filterText}
                                    onChange={handleFilterChange}
                                >
                                </TextField>
                            </Box>
                            <hr></hr>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell scope="col"></TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} scope="col">Item Name</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} scope="col">Size</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} scope="col">Category</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} scope="col">Price($)</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} scope="col">Quantity</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { filteredCustomerCateringMenus !== null? filteredCustomerCateringMenus.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((customerCateringMenu, index) => (
                                        <TableRow
                                            key={customerCateringMenu.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >

                                            <TableCell padding="checkbox">
                                                {/*<Checkbox
                                                    checked={isSelected(customerCateringMenu)}
                                                    onChange={(event) => handleSelectRow(event, customerCateringMenu)}
                                                />*/}
                                                <IconButton color='secondary' onClick={() =>{handleDeleteMenuItem(customerCateringMenu.customerSelectedMenuId)}}>
                                                    <DeleteIcon />
                                                </IconButton>
                                                {editingRowId === customerCateringMenu.customerSelectedMenuId ? (
                                                <IconButton color="primary" onClick={handleSaveClick}>
                                                    <SaveIcon />
                                                </IconButton>
                                                ) : (
                                                <IconButton color="secondary" onClick={() => handleEditClick(customerCateringMenu.customerSelectedMenuId)}>
                                                    <EditIcon />
                                                </IconButton>
                                                    )}
                                            </TableCell>

                                            {editingRowId === customerCateringMenu.customerSelectedMenuId ? (
                                                <>
                                                    <TableCell sx={{ fontSize: '1.1rem' }}>{customerCateringMenu.menuItemName}</TableCell>
                                                    <TableCell sx={{ fontSize: '1.1rem' }}>{customerCateringMenu.size}</TableCell>
                                                    <TableCell sx={{ fontSize: '1.1rem' }}>{customerCateringMenu.category}</TableCell>
                                                    <TableCell sx={{ fontSize: '1.1rem' }}>{customerCateringMenu.price}</TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            variant="standard"
                                                            value={parseInt(customerCateringMenu.quantity, 10) || 0}
                                                            onChange={(e) => handleInputChange(customerCateringMenu.customerSelectedMenuId, "quantity", e.target.value)}
                                                        />
                                                    </TableCell>
                                                </>
                                            ) : (
                                                <>

                                            <TableCell sx={{ fontSize: '1.1rem' }}>{customerCateringMenu.menuItemName}</TableCell>
                                            <TableCell sx={{ fontSize: '1.1rem' }}>{customerCateringMenu.size}</TableCell>
                                            <TableCell sx={{ fontSize: '1.1rem' }}>{customerCateringMenu.category}</TableCell>
                                            <TableCell sx={{ fontSize: '1.1rem' }}>{customerCateringMenu.price}</TableCell>
                                            <TableCell sx={{ fontSize: '1.1rem' }}>{parseInt(customerCateringMenu.quantity, 10) || 0}</TableCell>

                                                </>
                                            )}
                                        </TableRow>
                                    ) ): (<TableRow><TableCell>Loading... </TableCell></TableRow>)}
                                </TableBody>
                            </Table>
                            <TablePagination  sx={{ fontSize: '1.1rem' }}
                                              component="div"
                                              count={customerCateringMenus!= null? customerCateringMenus.length: 0}
                                              page={page}
                                              onPageChange={handleChangePage}
                                              rowsPerPage={rowsPerPage}
                                              onRowsPerPageChange={handleChangeRowsPerPage}
                                              rowsPerPageOptions={[5, 10, 25]}  // Options for rows per page
                            />
                        </TableContainer>
                    )}
                    {activeTab === 1 && (

                        <Card sx={{ width: '95%', padding: '2rem', border: '2px solid black', borderRadius: '8px' }}>

                            <TableContainer>
                                <Box display="flex" justifyContent="space-between" padding='2' >
                                    <Button color="primary" variant="contained"  onClick={handleAddItem} >
                                        Add Items
                                    </Button>
                                    <TextField
                                        label="Search Menus"
                                        variant="outlined"
                                        value={filterText}
                                        onChange={handleFilterChange}
                                    >
                                    </TextField>
                                </Box>
                                <hr></hr>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold' }} scope="col">#</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }} scope="col">Name</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }} scope="col">Description</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }} scope='col'>Size</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }} scope="col">Price($)</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        { filteredCateringMenus !== null? filteredCateringMenus.slice(addMenuPage * rowsPerAddMenuPage, addMenuPage * rowsPerAddMenuPage + rowsPerAddMenuPage).map((cateringmenu, index) => (
                                            <TableRow
                                                key={cateringmenu.id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isAdditionalMenuSelected(cateringmenu)}
                                                        onChange={(event) => handleAdditionalMenuRow(event, cateringmenu)}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '1.1rem' }}>{cateringmenu.name}</TableCell>
                                                <TableCell sx={{ fontSize: '1.1rem' }}>{cateringmenu.description}</TableCell>
                                                <TableCell sx={{ fontSize: '1.1rem' }}>{cateringmenu.size}</TableCell>
                                                <TableCell sx={{ fontSize: '1.1rem' }}>{cateringmenu.price}</TableCell>
                                            </TableRow>
                                        ) ): (<TableRow><TableCell>Loading... </TableCell></TableRow>)}
                                    </TableBody>
                                </Table>
                                <TablePagination  sx={{ fontSize: '1.1rem' }}
                                                  component="div"
                                                  count={cateringMenus!= null? cateringMenus.length: 0}
                                                  page={addMenuPage}
                                                  onPageChange={handleAddChangePage}
                                                  rowsPerPage={rowsPerAddMenuPage}
                                                  onRowsPerPageChange={handleAddChangeRowsPerPage}
                                                  rowsPerPageOptions={[5, 10, 25]}  // Options for rows per page
                                />
                            </TableContainer>
                            <hr></hr>
                        </Card>
                    )}
                </Box>

                <hr></hr>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseEdit} color="primary">
                    Cancel
                </Button>
                <Button color="primary" variant="contained"  onClick={handleEditCateringOrder} >
                    Update Catering Menu
                </Button>
            </DialogActions>
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            sx={{ zIndex: 2000 }}
        >
            <Alert
                onClose={handleSnackbarClose}
                severity={snackbarSeverity}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '80px'
                }}
            >
                {snackbarMessage}
            </Alert>
        </Snackbar>

    </Box>
  )
}

